export default __webpack_public_path__ + "static/media/imageProductContentOne.2aed88ab.png";